import { data } from '../../svg/Phone/data';
import { makeIcon } from '../makeIcon';

export const Phone = makeIcon(data, 'phone', 'Phone');

export default Phone;
